import { graphql } from "gatsby"
import React from "react"

import Button from "@atoms/Button/Button"
import ButtonGroup from "@molecules/ButtonGroup/ButtonGroup"

const CoreButtons = ({ buttons }) => {
  const buttonsMapped = buttons
    ?.map((button, index) => {
      const { className, href, text, target } = button
      const variant =
        className === "is-style-secondary" ? "secondary" : "primary"

      return (
        href &&
        text && (
          <Button
            key={index}
            href={href}
            linkTarget={target}
            variant={variant}
            anchorLink={href[0] === "#"}
            internalLink={target !== "_blank"}
          >
            {text}
          </Button>
        )
      )
    })
    .filter(Boolean)
  return <ButtonGroup>{buttonsMapped}</ButtonGroup>
}

export const query = graphql`
  fragment CoreButtons on WpBlockCoreButtons {
    __typename
    buttons {
      className
      href
      text
      target
    }
  }
`

export default CoreButtons
